
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { MapPin } from "lucide-react";

interface LocationPermissionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

export function LocationPermissionDialog({
  open,
  onOpenChange,
  onConfirm,
  onCancel,
}: LocationPermissionDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-black border-gray-800 text-[#FFFCF3]">
        <AlertDialogHeader>
          <div className="flex justify-center mb-2">
            <div className="bg-[#089BDF]/10 p-4 rounded-full">
              <MapPin className="h-8 w-8 text-[#089BDF]" />
            </div>
          </div>
          <AlertDialogTitle>Location Permission</AlertDialogTitle>
          <AlertDialogDescription>
            BeerDrop needs your location to verify you're at the venue before redeeming your voucher.
            <br /><br />
            Your location is only used for verification and is not stored.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel 
            onClick={onCancel}
            className="bg-gray-800 text-[#FFFCF3] hover:bg-gray-700"
          >
            Don't Allow
          </AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConfirm}
            className="bg-[#089BDF] text-white hover:bg-[#089BDF]/90"
          >
            Allow Location Access
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
